const ErrorField = ({ formik, name }) =>
  formik.errors[name] && formik.touched[name] ? (
    <label id="email-error" htmlFor="email" className="error-field">
      {formik.errors[name]}
    </label>
  ) : null

export default ErrorField
